import { render, staticRenderFns } from "./GradeScaleCopySlidebar.vue?vue&type=template&id=0cbdbacf"
import script from "./GradeScaleCopySlidebar.vue?vue&type=script&lang=js"
export * from "./GradeScaleCopySlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports